import {
	type DefaultPortableTextListItem,
	type PortableTextListComponent,
} from '@portabletext/react';
import styles from 'components/rich-text/pt-components/pt-components.module.scss';

export const list: Record<
	DefaultPortableTextListItem,
	PortableTextListComponent
> = {
	bullet: ({ children }) => <ul className={styles.ul}>{children}</ul>,
	number: ({ children }) => <ol className={styles.ol}>{children}</ol>,
};

export default list;
